// Discord's timestamps, for every module's "Copy for Discord": Discord shows them in
// each reader's own time zone.

/** Discord's timestamp styles: `t`, `T`, `d`, `D`, `f`, `F` and `R` (relative). */
export type StampStyle = 't' | 'T' | 'd' | 'D' | 'f' | 'F' | 'R';

/** A Discord timestamp: `<t:seconds:style>`. */
export function stamp(at: Date, style: StampStyle): string {
  return `<t:${String(Math.floor(at.getTime() / 1000))}:${style}>`;
}

/** `Oct 30`: the copier's local date, for a report's title. */
export function monthDay(at: Date): string {
  return at.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
